export default __webpack_public_path__ + "images/apartamentoDefault.6398f4d3bab68c48dea915f1ca77c2cc.jpg";